import {
    CGF300Code,
    CGF350Code,
    CGF400Code,
    CGS200Code,
    GlassThicknessCode1_4,
    GlassThicknessCode3_16,
    GlassThicknessCode3_8,
    KompasDblCode,
    KompasSglCode,
    RomanoCode,
    TreviCode,
} from "./index";

export const defaultGlassStructureCode = {
    [KompasSglCode]: GlassThicknessCode1_4,
    [KompasDblCode]: GlassThicknessCode1_4,
    [CGS200Code]: GlassThicknessCode3_8,
    [CGF300Code]: GlassThicknessCode3_8,
    [CGF350Code]: GlassThicknessCode3_8,
    [CGF400Code]: GlassThicknessCode3_8,
    [RomanoCode]: GlassThicknessCode3_16,
    [TreviCode]: GlassThicknessCode3_16,
};
